import React from "react";
import { Card, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useAppDispatch } from "../../utils/hooks/redux";
import { openModal } from "../../redux/features/whiteboard/whiteboardSlice";
import WhiteboardTable from "./components/WhiteboardTable";
import WhiteboardModal from "./components/WhiteboardModal";
import { StyledButton } from "../../components/styles";
import { PageHeader, WhiteboardContainer, WhiteTitle } from "./styles";

const { Title } = Typography;

const Whiteboard: React.FC = () => {
  const dispatch = useAppDispatch();

  const handleAddNew = () => {
    dispatch(openModal(null));
  };

  return (
    <WhiteboardContainer>
      <PageHeader>
        <WhiteTitle level={5}>WhiteBoard</WhiteTitle>
        <StyledButton type="primary" icon={<PlusOutlined />} onClick={handleAddNew}>
          Add Message
        </StyledButton>
      </PageHeader>
      <WhiteboardTable />
      <WhiteboardModal />
    </WhiteboardContainer>
  );
};

export default Whiteboard;
